import { render } from "./sipNumber.vue?vue&type=template&id=60c8f307&scoped=true"
import script from "./sipNumber.vue?vue&type=script&lang=js"
export * from "./sipNumber.vue?vue&type=script&lang=js"

import "./sipNumber.vue?vue&type=style&index=0&id=60c8f307&scoped=true&lang=css"
import "./sipNumber.vue?vue&type=style&index=1&id=60c8f307&lang=css"
script.render = render
script.__scopeId = "data-v-60c8f307"

export default script